/**
 * External dependencies
 */
import React from "react";
import { connect } from "react-redux";
import { Box } from "@towersystems/towersystems-design-system";
import page from "page";
import { noop, map } from "lodash";

/**
 * Internal dependencies
 */
import Button from "components/button";
import ButtonGroup from "components/button-group";
import { startEditing } from "state/ui/dashboard-form/actions";
import PageHeader from "layout/page-header";
import { isModalVisible } from "state/ui/selectors";
import { getName, getLayoutId } from "state/dashboard/selectors";
import { getAllLayouts } from "state/dashboard-layouts/selectors";
import DateRangePicker from "blocks/date-range-picker";

/**
 * Style dependencies
 */
import "./styles.scss";

const DashboardHeader = ({
  newDashboardFocused = noop,
  activeDashboardId,
  dashboards = [],
  title,
  ...props
}) => {
  const headerItems =
    dashboards.length >= 1 &&
    map(dashboards, (dashboard) => {
      return {
        key: dashboard.id,
        label: dashboard.name,
        onClick: () => page(`/decks/${dashboard.id}`),
        active: activeDashboardId === dashboard.id,
      };
    });

  return (
    <React.Fragment>
      <PageHeader
        subtitle={<DateRangePicker />}
        actions={
          <Box display="flex">
            <ButtonGroup className="dashboard-header__actions">
              <Button
                isActive={newDashboardFocused}
                onClick={() => props.startEditing()}
                secondary
                lined
              >
                New deck
              </Button>
              <Button
                onClick={() => page("/reports/report-library")}
                secondary
                borderless
              >
                Add view
              </Button>
            </ButtonGroup>
          </Box>
        }
        className="dashboard__header"
      ></PageHeader>
    </React.Fragment>
  );
};

export default connect(
  (state) => {
    let activeDashboardId = getLayoutId(state);
    let dashboards = getAllLayouts(state);

    return {
      newDashboardFocused: isModalVisible("EditDashboardPopover")(state),
      title: getName(state),
      dashboards,
      activeDashboardId,
    };
  },
  { startEditing }
)(DashboardHeader);
